import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-added",
  "use": "icon-added-usage",
  "viewBox": "0 0 19.164 19.163",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.164 19.163\" id=\"icon-added\">\r\n  <path id=\"icon-added_xinjian-2\" d=\"M18.479,13.688H15.057V10.266a.684.684,0,0,0-1.369,0v3.422H10.266a.684.684,0,0,0,0,1.369h3.422v3.422a.684.684,0,1,0,1.369,0V15.057h3.422a.684.684,0,1,0,0-1.369ZM8.213,17.794H2.053a.686.686,0,0,1-.684-.684V2.053a.678.678,0,0,1,.684-.684H17.11a.686.686,0,0,1,.684.684v6.16a.685.685,0,1,0,1.369,0V1.369A1.373,1.373,0,0,0,17.794,0H1.369A1.373,1.373,0,0,0,0,1.369V17.794a1.373,1.373,0,0,0,1.369,1.369H8.213a.685.685,0,1,0,0-1.369Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/added.svg
// module id = yL/A
// module chunks = 5